import React, { useState, useEffect } from 'react';
import { getTickets, createTicket, updateTicket } from '../services/api';
import { useToast } from '../components/Toast';

function Tickets({ user }) {
  const toast = useToast();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [asunto, setAsunto] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    cargarTickets();
  }, []);

  const cargarTickets = async () => {
    try {
      setLoading(true);
      const res = await getTickets();
      setTickets(res.data || []);
    } catch {
      toast.error('Error cargando tickets');
    } finally {
      setLoading(false);
    }
  };

  const handleCrear = async (e) => {
    e.preventDefault();
    if (!asunto.trim() || !descripcion.trim()) {
      toast.error('Rellena todos los campos');
      return;
    }
    setEnviando(true);
    try {
      await createTicket({ asunto: asunto.trim(), descripcion: descripcion.trim() });
      toast.success('Ticket enviado correctamente');
      setAsunto('');
      setDescripcion('');
      cargarTickets();
    } catch {
      toast.error('Error al crear ticket');
    } finally {
      setEnviando(false);
    }
  };

  const handleCambiarEstado = async (id, estado) => {
    try {
      await updateTicket(id, { estado });
      toast.success('Estado actualizado');
      cargarTickets();
    } catch {
      toast.error('Error al actualizar');
    }
  };

  const getEstadoBadge = (estado) => {
    const colores = {
      abierto: '#3b82f6',
      en_progreso: '#f59e0b',
      resuelto: '#10b981',
      cerrado: '#6b7280'
    };
    return {
      backgroundColor: colores[estado] || '#6b7280',
      color: 'white',
      padding: '3px 10px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '600'
    };
  };

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="container" style={{ paddingTop: '40px' }}>
      <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '24px' }}>🎫 Tickets de soporte</h1>

      <div className="card" style={{ marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Reportar un problema</h3>
        <form onSubmit={handleCrear}>
          <div className="form-group">
            <label className="form-label">Asunto *</label>
            <input
              className="form-control"
              value={asunto}
              onChange={(e) => setAsunto(e.target.value)}
              placeholder="Describe brevemente el problema"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Descripcion *</label>
            <textarea
              className="form-control"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Explica los pasos para reproducir el fallo, que esperabas que pasara, etc."
              rows={4}
              required
              style={{ resize: 'vertical' }}
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={enviando}>
            {enviando ? 'Enviando...' : 'Enviar ticket'}
          </button>
        </form>
      </div>

      <div className="card">
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>
          Mis tickets ({tickets.length})
        </h3>
        {tickets.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)' }}>No hay tickets</p>
        ) : (
          <div style={{ display: 'grid', gap: '12px' }}>
            {tickets.map(ticket => (
              <div key={ticket.id} className="card" style={{ padding: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'wrap', gap: '8px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>{ticket.asunto}</div>
                    <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>{ticket.descripcion}</p>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={getEstadoBadge(ticket.estado)}>{ticket.estado.replace('_', ' ')}</span>
                      {(user.rol === 'administrador' || user.rol === 'empleado') && ticket.usuario_nombre && (
                        <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                          por {ticket.usuario_nombre}
                        </span>
                      )}
                      <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                        {new Date(ticket.fecha_creacion).toLocaleString('es-ES')}
                      </span>
                    </div>
                  </div>
                  {(user.rol === 'administrador' || user.rol === 'empleado') && (
                    <select
                      className="form-control"
                      value={ticket.estado}
                      onChange={(e) => handleCambiarEstado(ticket.id, e.target.value)}
                      style={{ width: 'auto', fontSize: '13px' }}
                    >
                      <option value="abierto">Abierto</option>
                      <option value="en_progreso">En progreso</option>
                      <option value="resuelto">Resuelto</option>
                      <option value="cerrado">Cerrado</option>
                    </select>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Tickets;
